import { Upgrade } from "./types";
import { boolean, number, stringF, object } from "./helpers";

export const upgrade = object<Upgrade>({
  auto: object({
    enable: boolean("ENABLE_AUTO_UPDATE"),
    server: object({
      address: stringF("UPDATE_SERVER_ADDRESS")
    }),
    polling: object({
      interval: number("unused")
    }),
    timeFrame: object({
      enable: boolean("SCHEDULE_UPDATE_CHECKS"),
      startTime: stringF("FROM"),
      stopTime: stringF("TO")
    })
  })
});
